/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SrTokenRouteImport } from './routes/sr.$token'
import { Route as STokenRouteImport } from './routes/s.$token'
import { Route as MarketplaceVendorInviteRouteImport } from './routes/marketplace.vendor-invite'
import { Route as AuthMcpAuthorizeRouteImport } from './routes/auth/mcp-authorize'
import { Route as AuthLinkRouteImport } from './routes/auth/link'
import { Route as AuthInviteRouteImport } from './routes/auth/invite'
import { Route as AuthForgotPasswordRouteImport } from './routes/auth/forgot-password'
import { Route as AuthActionRouteImport } from './routes/auth/action'
import { Route as AuthenticatedWorkspaceRouteImport } from './routes/_authenticated/workspace'
import { Route as AuthenticatedScriptDeliveryRouteImport } from './routes/_authenticated/script-delivery'
import { Route as AuthenticatedPromptsRouteImport } from './routes/_authenticated/prompts'
import { Route as AuthenticatedPreFlightScriptsRouteImport } from './routes/_authenticated/pre-flight-scripts'
import { Route as AuthenticatedPreFlightRouteImport } from './routes/_authenticated/pre-flight'
import { Route as AuthenticatedPostFlightRouteImport } from './routes/_authenticated/post-flight'
import { Route as AuthenticatedPersonasRouteImport } from './routes/_authenticated/personas'
import { Route as AuthenticatedPersonaOpportunitiesRouteImport } from './routes/_authenticated/persona-opportunities'
import { Route as AuthenticatedOverviewRouteImport } from './routes/_authenticated/overview'
import { Route as AuthenticatedOrderStatusTimeRouteImport } from './routes/_authenticated/order-status-time'
import { Route as AuthenticatedOpportunitiesRouteImport } from './routes/_authenticated/opportunities'
import { Route as AuthenticatedMarketplaceRouteImport } from './routes/_authenticated/marketplace'
import { Route as AuthenticatedIamRouteImport } from './routes/_authenticated/iam'
import { Route as AuthenticatedDrilldownRouteImport } from './routes/_authenticated/drilldown'
import { Route as AuthenticatedDashboardRouteImport } from './routes/_authenticated/dashboard'
import { Route as AuthenticatedBrandBrainRouteImport } from './routes/_authenticated/brand-brain'
import { Route as AuthenticatedBetaFeaturesRouteImport } from './routes/_authenticated/beta-features'
import { Route as AuthenticatedApiTokensRouteImport } from './routes/_authenticated/api-tokens'
import { Route as AuthenticatedAdminRouteImport } from './routes/_authenticated/admin'
import { Route as AuthenticatedPreFlightIndexRouteImport } from './routes/_authenticated/pre-flight.index'
import { Route as AuthenticatedPreFlightScriptsIndexRouteImport } from './routes/_authenticated/pre-flight-scripts.index'
import { Route as AuthenticatedPostFlightIndexRouteImport } from './routes/_authenticated/post-flight.index'
import { Route as AuthenticatedMarketplaceIndexRouteImport } from './routes/_authenticated/marketplace.index'
import { Route as AuthenticatedMarketplacePartnerRouteImport } from './routes/_authenticated/marketplace.partner'
import { Route as AuthenticatedMarketplaceOrdersRouteImport } from './routes/_authenticated/marketplace.orders'
import { Route as AuthenticatedMarketplaceImportRouteImport } from './routes/_authenticated/marketplace.import'
import { Route as AuthenticatedMarketplaceAdminRouteImport } from './routes/_authenticated/marketplace.admin'
import { Route as AuthenticatedMarketplacePartnerIndexRouteImport } from './routes/_authenticated/marketplace.partner.index'
import { Route as AuthenticatedPreFlightReportsReportIdRouteImport } from './routes/_authenticated/pre-flight.reports.$reportId'
import { Route as AuthenticatedPreFlightScriptsReviewReviewIdRouteImport } from './routes/_authenticated/pre-flight-scripts.review.$reviewId'
import { Route as AuthenticatedMarketplacePartnerReviewsReviewIdRouteImport } from './routes/_authenticated/marketplace.partner.reviews.$reviewId'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SrTokenRoute = SrTokenRouteImport.update({
  id: '/sr/$token',
  path: '/sr/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const STokenRoute = STokenRouteImport.update({
  id: '/s/$token',
  path: '/s/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const MarketplaceVendorInviteRoute = MarketplaceVendorInviteRouteImport.update({
  id: '/marketplace/vendor-invite',
  path: '/marketplace/vendor-invite',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthMcpAuthorizeRoute = AuthMcpAuthorizeRouteImport.update({
  id: '/auth/mcp-authorize',
  path: '/auth/mcp-authorize',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthLinkRoute = AuthLinkRouteImport.update({
  id: '/auth/link',
  path: '/auth/link',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthInviteRoute = AuthInviteRouteImport.update({
  id: '/auth/invite',
  path: '/auth/invite',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthForgotPasswordRoute = AuthForgotPasswordRouteImport.update({
  id: '/auth/forgot-password',
  path: '/auth/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthActionRoute = AuthActionRouteImport.update({
  id: '/auth/action',
  path: '/auth/action',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedWorkspaceRoute = AuthenticatedWorkspaceRouteImport.update({
  id: '/workspace',
  path: '/workspace',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedScriptDeliveryRoute =
  AuthenticatedScriptDeliveryRouteImport.update({
    id: '/script-delivery',
    path: '/script-delivery',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPromptsRoute = AuthenticatedPromptsRouteImport.update({
  id: '/prompts',
  path: '/prompts',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedPreFlightScriptsRoute =
  AuthenticatedPreFlightScriptsRouteImport.update({
    id: '/pre-flight-scripts',
    path: '/pre-flight-scripts',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPreFlightRoute = AuthenticatedPreFlightRouteImport.update({
  id: '/pre-flight',
  path: '/pre-flight',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedPostFlightRoute = AuthenticatedPostFlightRouteImport.update({
  id: '/post-flight',
  path: '/post-flight',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedPersonasRoute = AuthenticatedPersonasRouteImport.update({
  id: '/personas',
  path: '/personas',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedPersonaOpportunitiesRoute =
  AuthenticatedPersonaOpportunitiesRouteImport.update({
    id: '/persona-opportunities',
    path: '/persona-opportunities',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedOverviewRoute = AuthenticatedOverviewRouteImport.update({
  id: '/overview',
  path: '/overview',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedOrderStatusTimeRoute =
  AuthenticatedOrderStatusTimeRouteImport.update({
    id: '/order-status-time',
    path: '/order-status-time',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedOpportunitiesRoute =
  AuthenticatedOpportunitiesRouteImport.update({
    id: '/opportunities',
    path: '/opportunities',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedMarketplaceRoute =
  AuthenticatedMarketplaceRouteImport.update({
    id: '/marketplace',
    path: '/marketplace',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedIamRoute = AuthenticatedIamRouteImport.update({
  id: '/iam',
  path: '/iam',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedDrilldownRoute = AuthenticatedDrilldownRouteImport.update({
  id: '/drilldown',
  path: '/drilldown',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedBrandBrainRoute = AuthenticatedBrandBrainRouteImport.update({
  id: '/brand-brain',
  path: '/brand-brain',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedBetaFeaturesRoute =
  AuthenticatedBetaFeaturesRouteImport.update({
    id: '/beta-features',
    path: '/beta-features',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedApiTokensRoute = AuthenticatedApiTokensRouteImport.update({
  id: '/api-tokens',
  path: '/api-tokens',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAdminRoute = AuthenticatedAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedPreFlightIndexRoute =
  AuthenticatedPreFlightIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedPreFlightRoute,
  } as any)
const AuthenticatedPreFlightScriptsIndexRoute =
  AuthenticatedPreFlightScriptsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedPreFlightScriptsRoute,
  } as any)
const AuthenticatedPostFlightIndexRoute =
  AuthenticatedPostFlightIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedPostFlightRoute,
  } as any)
const AuthenticatedMarketplaceIndexRoute =
  AuthenticatedMarketplaceIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedMarketplaceRoute,
  } as any)
const AuthenticatedMarketplacePartnerRoute =
  AuthenticatedMarketplacePartnerRouteImport.update({
    id: '/partner',
    path: '/partner',
    getParentRoute: () => AuthenticatedMarketplaceRoute,
  } as any)
const AuthenticatedMarketplaceOrdersRoute =
  AuthenticatedMarketplaceOrdersRouteImport.update({
    id: '/orders',
    path: '/orders',
    getParentRoute: () => AuthenticatedMarketplaceRoute,
  } as any)
const AuthenticatedMarketplaceImportRoute =
  AuthenticatedMarketplaceImportRouteImport.update({
    id: '/import',
    path: '/import',
    getParentRoute: () => AuthenticatedMarketplaceRoute,
  } as any)
const AuthenticatedMarketplaceAdminRoute =
  AuthenticatedMarketplaceAdminRouteImport.update({
    id: '/admin',
    path: '/admin',
    getParentRoute: () => AuthenticatedMarketplaceRoute,
  } as any)
const AuthenticatedMarketplacePartnerIndexRoute =
  AuthenticatedMarketplacePartnerIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedMarketplacePartnerRoute,
  } as any)
const AuthenticatedPreFlightReportsReportIdRoute =
  AuthenticatedPreFlightReportsReportIdRouteImport.update({
    id: '/reports/$reportId',
    path: '/reports/$reportId',
    getParentRoute: () => AuthenticatedPreFlightRoute,
  } as any)
const AuthenticatedPreFlightScriptsReviewReviewIdRoute =
  AuthenticatedPreFlightScriptsReviewReviewIdRouteImport.update({
    id: '/review/$reviewId',
    path: '/review/$reviewId',
    getParentRoute: () => AuthenticatedPreFlightScriptsRoute,
  } as any)
const AuthenticatedMarketplacePartnerReviewsReviewIdRoute =
  AuthenticatedMarketplacePartnerReviewsReviewIdRouteImport.update({
    id: '/reviews/$reviewId',
    path: '/reviews/$reviewId',
    getParentRoute: () => AuthenticatedMarketplacePartnerRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/admin': typeof AuthenticatedAdminRoute
  '/api-tokens': typeof AuthenticatedApiTokensRoute
  '/beta-features': typeof AuthenticatedBetaFeaturesRoute
  '/brand-brain': typeof AuthenticatedBrandBrainRoute
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/drilldown': typeof AuthenticatedDrilldownRoute
  '/iam': typeof AuthenticatedIamRoute
  '/marketplace': typeof AuthenticatedMarketplaceRouteWithChildren
  '/opportunities': typeof AuthenticatedOpportunitiesRoute
  '/order-status-time': typeof AuthenticatedOrderStatusTimeRoute
  '/overview': typeof AuthenticatedOverviewRoute
  '/persona-opportunities': typeof AuthenticatedPersonaOpportunitiesRoute
  '/personas': typeof AuthenticatedPersonasRoute
  '/post-flight': typeof AuthenticatedPostFlightRouteWithChildren
  '/pre-flight': typeof AuthenticatedPreFlightRouteWithChildren
  '/pre-flight-scripts': typeof AuthenticatedPreFlightScriptsRouteWithChildren
  '/prompts': typeof AuthenticatedPromptsRoute
  '/script-delivery': typeof AuthenticatedScriptDeliveryRoute
  '/workspace': typeof AuthenticatedWorkspaceRoute
  '/auth/action': typeof AuthActionRoute
  '/auth/forgot-password': typeof AuthForgotPasswordRoute
  '/auth/invite': typeof AuthInviteRoute
  '/auth/link': typeof AuthLinkRoute
  '/auth/mcp-authorize': typeof AuthMcpAuthorizeRoute
  '/marketplace/vendor-invite': typeof MarketplaceVendorInviteRoute
  '/s/$token': typeof STokenRoute
  '/sr/$token': typeof SrTokenRoute
  '/marketplace/admin': typeof AuthenticatedMarketplaceAdminRoute
  '/marketplace/import': typeof AuthenticatedMarketplaceImportRoute
  '/marketplace/orders': typeof AuthenticatedMarketplaceOrdersRoute
  '/marketplace/partner': typeof AuthenticatedMarketplacePartnerRouteWithChildren
  '/marketplace/': typeof AuthenticatedMarketplaceIndexRoute
  '/post-flight/': typeof AuthenticatedPostFlightIndexRoute
  '/pre-flight-scripts/': typeof AuthenticatedPreFlightScriptsIndexRoute
  '/pre-flight/': typeof AuthenticatedPreFlightIndexRoute
  '/pre-flight-scripts/review/$reviewId': typeof AuthenticatedPreFlightScriptsReviewReviewIdRoute
  '/pre-flight/reports/$reportId': typeof AuthenticatedPreFlightReportsReportIdRoute
  '/marketplace/partner/': typeof AuthenticatedMarketplacePartnerIndexRoute
  '/marketplace/partner/reviews/$reviewId': typeof AuthenticatedMarketplacePartnerReviewsReviewIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/admin': typeof AuthenticatedAdminRoute
  '/api-tokens': typeof AuthenticatedApiTokensRoute
  '/beta-features': typeof AuthenticatedBetaFeaturesRoute
  '/brand-brain': typeof AuthenticatedBrandBrainRoute
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/drilldown': typeof AuthenticatedDrilldownRoute
  '/iam': typeof AuthenticatedIamRoute
  '/opportunities': typeof AuthenticatedOpportunitiesRoute
  '/order-status-time': typeof AuthenticatedOrderStatusTimeRoute
  '/overview': typeof AuthenticatedOverviewRoute
  '/persona-opportunities': typeof AuthenticatedPersonaOpportunitiesRoute
  '/personas': typeof AuthenticatedPersonasRoute
  '/prompts': typeof AuthenticatedPromptsRoute
  '/script-delivery': typeof AuthenticatedScriptDeliveryRoute
  '/workspace': typeof AuthenticatedWorkspaceRoute
  '/auth/action': typeof AuthActionRoute
  '/auth/forgot-password': typeof AuthForgotPasswordRoute
  '/auth/invite': typeof AuthInviteRoute
  '/auth/link': typeof AuthLinkRoute
  '/auth/mcp-authorize': typeof AuthMcpAuthorizeRoute
  '/marketplace/vendor-invite': typeof MarketplaceVendorInviteRoute
  '/s/$token': typeof STokenRoute
  '/sr/$token': typeof SrTokenRoute
  '/marketplace/admin': typeof AuthenticatedMarketplaceAdminRoute
  '/marketplace/import': typeof AuthenticatedMarketplaceImportRoute
  '/marketplace/orders': typeof AuthenticatedMarketplaceOrdersRoute
  '/marketplace': typeof AuthenticatedMarketplaceIndexRoute
  '/post-flight': typeof AuthenticatedPostFlightIndexRoute
  '/pre-flight-scripts': typeof AuthenticatedPreFlightScriptsIndexRoute
  '/pre-flight': typeof AuthenticatedPreFlightIndexRoute
  '/pre-flight-scripts/review/$reviewId': typeof AuthenticatedPreFlightScriptsReviewReviewIdRoute
  '/pre-flight/reports/$reportId': typeof AuthenticatedPreFlightReportsReportIdRoute
  '/marketplace/partner': typeof AuthenticatedMarketplacePartnerIndexRoute
  '/marketplace/partner/reviews/$reviewId': typeof AuthenticatedMarketplacePartnerReviewsReviewIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/login': typeof LoginRoute
  '/_authenticated/admin': typeof AuthenticatedAdminRoute
  '/_authenticated/api-tokens': typeof AuthenticatedApiTokensRoute
  '/_authenticated/beta-features': typeof AuthenticatedBetaFeaturesRoute
  '/_authenticated/brand-brain': typeof AuthenticatedBrandBrainRoute
  '/_authenticated/dashboard': typeof AuthenticatedDashboardRoute
  '/_authenticated/drilldown': typeof AuthenticatedDrilldownRoute
  '/_authenticated/iam': typeof AuthenticatedIamRoute
  '/_authenticated/marketplace': typeof AuthenticatedMarketplaceRouteWithChildren
  '/_authenticated/opportunities': typeof AuthenticatedOpportunitiesRoute
  '/_authenticated/order-status-time': typeof AuthenticatedOrderStatusTimeRoute
  '/_authenticated/overview': typeof AuthenticatedOverviewRoute
  '/_authenticated/persona-opportunities': typeof AuthenticatedPersonaOpportunitiesRoute
  '/_authenticated/personas': typeof AuthenticatedPersonasRoute
  '/_authenticated/post-flight': typeof AuthenticatedPostFlightRouteWithChildren
  '/_authenticated/pre-flight': typeof AuthenticatedPreFlightRouteWithChildren
  '/_authenticated/pre-flight-scripts': typeof AuthenticatedPreFlightScriptsRouteWithChildren
  '/_authenticated/prompts': typeof AuthenticatedPromptsRoute
  '/_authenticated/script-delivery': typeof AuthenticatedScriptDeliveryRoute
  '/_authenticated/workspace': typeof AuthenticatedWorkspaceRoute
  '/auth/action': typeof AuthActionRoute
  '/auth/forgot-password': typeof AuthForgotPasswordRoute
  '/auth/invite': typeof AuthInviteRoute
  '/auth/link': typeof AuthLinkRoute
  '/auth/mcp-authorize': typeof AuthMcpAuthorizeRoute
  '/marketplace/vendor-invite': typeof MarketplaceVendorInviteRoute
  '/s/$token': typeof STokenRoute
  '/sr/$token': typeof SrTokenRoute
  '/_authenticated/marketplace/admin': typeof AuthenticatedMarketplaceAdminRoute
  '/_authenticated/marketplace/import': typeof AuthenticatedMarketplaceImportRoute
  '/_authenticated/marketplace/orders': typeof AuthenticatedMarketplaceOrdersRoute
  '/_authenticated/marketplace/partner': typeof AuthenticatedMarketplacePartnerRouteWithChildren
  '/_authenticated/marketplace/': typeof AuthenticatedMarketplaceIndexRoute
  '/_authenticated/post-flight/': typeof AuthenticatedPostFlightIndexRoute
  '/_authenticated/pre-flight-scripts/': typeof AuthenticatedPreFlightScriptsIndexRoute
  '/_authenticated/pre-flight/': typeof AuthenticatedPreFlightIndexRoute
  '/_authenticated/pre-flight-scripts/review/$reviewId': typeof AuthenticatedPreFlightScriptsReviewReviewIdRoute
  '/_authenticated/pre-flight/reports/$reportId': typeof AuthenticatedPreFlightReportsReportIdRoute
  '/_authenticated/marketplace/partner/': typeof AuthenticatedMarketplacePartnerIndexRoute
  '/_authenticated/marketplace/partner/reviews/$reviewId': typeof AuthenticatedMarketplacePartnerReviewsReviewIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/admin'
    | '/api-tokens'
    | '/beta-features'
    | '/brand-brain'
    | '/dashboard'
    | '/drilldown'
    | '/iam'
    | '/marketplace'
    | '/opportunities'
    | '/order-status-time'
    | '/overview'
    | '/persona-opportunities'
    | '/personas'
    | '/post-flight'
    | '/pre-flight'
    | '/pre-flight-scripts'
    | '/prompts'
    | '/script-delivery'
    | '/workspace'
    | '/auth/action'
    | '/auth/forgot-password'
    | '/auth/invite'
    | '/auth/link'
    | '/auth/mcp-authorize'
    | '/marketplace/vendor-invite'
    | '/s/$token'
    | '/sr/$token'
    | '/marketplace/admin'
    | '/marketplace/import'
    | '/marketplace/orders'
    | '/marketplace/partner'
    | '/marketplace/'
    | '/post-flight/'
    | '/pre-flight-scripts/'
    | '/pre-flight/'
    | '/pre-flight-scripts/review/$reviewId'
    | '/pre-flight/reports/$reportId'
    | '/marketplace/partner/'
    | '/marketplace/partner/reviews/$reviewId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/admin'
    | '/api-tokens'
    | '/beta-features'
    | '/brand-brain'
    | '/dashboard'
    | '/drilldown'
    | '/iam'
    | '/opportunities'
    | '/order-status-time'
    | '/overview'
    | '/persona-opportunities'
    | '/personas'
    | '/prompts'
    | '/script-delivery'
    | '/workspace'
    | '/auth/action'
    | '/auth/forgot-password'
    | '/auth/invite'
    | '/auth/link'
    | '/auth/mcp-authorize'
    | '/marketplace/vendor-invite'
    | '/s/$token'
    | '/sr/$token'
    | '/marketplace/admin'
    | '/marketplace/import'
    | '/marketplace/orders'
    | '/marketplace'
    | '/post-flight'
    | '/pre-flight-scripts'
    | '/pre-flight'
    | '/pre-flight-scripts/review/$reviewId'
    | '/pre-flight/reports/$reportId'
    | '/marketplace/partner'
    | '/marketplace/partner/reviews/$reviewId'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/login'
    | '/_authenticated/admin'
    | '/_authenticated/api-tokens'
    | '/_authenticated/beta-features'
    | '/_authenticated/brand-brain'
    | '/_authenticated/dashboard'
    | '/_authenticated/drilldown'
    | '/_authenticated/iam'
    | '/_authenticated/marketplace'
    | '/_authenticated/opportunities'
    | '/_authenticated/order-status-time'
    | '/_authenticated/overview'
    | '/_authenticated/persona-opportunities'
    | '/_authenticated/personas'
    | '/_authenticated/post-flight'
    | '/_authenticated/pre-flight'
    | '/_authenticated/pre-flight-scripts'
    | '/_authenticated/prompts'
    | '/_authenticated/script-delivery'
    | '/_authenticated/workspace'
    | '/auth/action'
    | '/auth/forgot-password'
    | '/auth/invite'
    | '/auth/link'
    | '/auth/mcp-authorize'
    | '/marketplace/vendor-invite'
    | '/s/$token'
    | '/sr/$token'
    | '/_authenticated/marketplace/admin'
    | '/_authenticated/marketplace/import'
    | '/_authenticated/marketplace/orders'
    | '/_authenticated/marketplace/partner'
    | '/_authenticated/marketplace/'
    | '/_authenticated/post-flight/'
    | '/_authenticated/pre-flight-scripts/'
    | '/_authenticated/pre-flight/'
    | '/_authenticated/pre-flight-scripts/review/$reviewId'
    | '/_authenticated/pre-flight/reports/$reportId'
    | '/_authenticated/marketplace/partner/'
    | '/_authenticated/marketplace/partner/reviews/$reviewId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  LoginRoute: typeof LoginRoute
  AuthActionRoute: typeof AuthActionRoute
  AuthForgotPasswordRoute: typeof AuthForgotPasswordRoute
  AuthInviteRoute: typeof AuthInviteRoute
  AuthLinkRoute: typeof AuthLinkRoute
  AuthMcpAuthorizeRoute: typeof AuthMcpAuthorizeRoute
  MarketplaceVendorInviteRoute: typeof MarketplaceVendorInviteRoute
  STokenRoute: typeof STokenRoute
  SrTokenRoute: typeof SrTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sr/$token': {
      id: '/sr/$token'
      path: '/sr/$token'
      fullPath: '/sr/$token'
      preLoaderRoute: typeof SrTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/s/$token': {
      id: '/s/$token'
      path: '/s/$token'
      fullPath: '/s/$token'
      preLoaderRoute: typeof STokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/marketplace/vendor-invite': {
      id: '/marketplace/vendor-invite'
      path: '/marketplace/vendor-invite'
      fullPath: '/marketplace/vendor-invite'
      preLoaderRoute: typeof MarketplaceVendorInviteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/mcp-authorize': {
      id: '/auth/mcp-authorize'
      path: '/auth/mcp-authorize'
      fullPath: '/auth/mcp-authorize'
      preLoaderRoute: typeof AuthMcpAuthorizeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/link': {
      id: '/auth/link'
      path: '/auth/link'
      fullPath: '/auth/link'
      preLoaderRoute: typeof AuthLinkRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/invite': {
      id: '/auth/invite'
      path: '/auth/invite'
      fullPath: '/auth/invite'
      preLoaderRoute: typeof AuthInviteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/forgot-password': {
      id: '/auth/forgot-password'
      path: '/auth/forgot-password'
      fullPath: '/auth/forgot-password'
      preLoaderRoute: typeof AuthForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/action': {
      id: '/auth/action'
      path: '/auth/action'
      fullPath: '/auth/action'
      preLoaderRoute: typeof AuthActionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/workspace': {
      id: '/_authenticated/workspace'
      path: '/workspace'
      fullPath: '/workspace'
      preLoaderRoute: typeof AuthenticatedWorkspaceRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/script-delivery': {
      id: '/_authenticated/script-delivery'
      path: '/script-delivery'
      fullPath: '/script-delivery'
      preLoaderRoute: typeof AuthenticatedScriptDeliveryRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/prompts': {
      id: '/_authenticated/prompts'
      path: '/prompts'
      fullPath: '/prompts'
      preLoaderRoute: typeof AuthenticatedPromptsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/pre-flight-scripts': {
      id: '/_authenticated/pre-flight-scripts'
      path: '/pre-flight-scripts'
      fullPath: '/pre-flight-scripts'
      preLoaderRoute: typeof AuthenticatedPreFlightScriptsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/pre-flight': {
      id: '/_authenticated/pre-flight'
      path: '/pre-flight'
      fullPath: '/pre-flight'
      preLoaderRoute: typeof AuthenticatedPreFlightRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/post-flight': {
      id: '/_authenticated/post-flight'
      path: '/post-flight'
      fullPath: '/post-flight'
      preLoaderRoute: typeof AuthenticatedPostFlightRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/personas': {
      id: '/_authenticated/personas'
      path: '/personas'
      fullPath: '/personas'
      preLoaderRoute: typeof AuthenticatedPersonasRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/persona-opportunities': {
      id: '/_authenticated/persona-opportunities'
      path: '/persona-opportunities'
      fullPath: '/persona-opportunities'
      preLoaderRoute: typeof AuthenticatedPersonaOpportunitiesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/overview': {
      id: '/_authenticated/overview'
      path: '/overview'
      fullPath: '/overview'
      preLoaderRoute: typeof AuthenticatedOverviewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/order-status-time': {
      id: '/_authenticated/order-status-time'
      path: '/order-status-time'
      fullPath: '/order-status-time'
      preLoaderRoute: typeof AuthenticatedOrderStatusTimeRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/opportunities': {
      id: '/_authenticated/opportunities'
      path: '/opportunities'
      fullPath: '/opportunities'
      preLoaderRoute: typeof AuthenticatedOpportunitiesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/marketplace': {
      id: '/_authenticated/marketplace'
      path: '/marketplace'
      fullPath: '/marketplace'
      preLoaderRoute: typeof AuthenticatedMarketplaceRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/iam': {
      id: '/_authenticated/iam'
      path: '/iam'
      fullPath: '/iam'
      preLoaderRoute: typeof AuthenticatedIamRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/drilldown': {
      id: '/_authenticated/drilldown'
      path: '/drilldown'
      fullPath: '/drilldown'
      preLoaderRoute: typeof AuthenticatedDrilldownRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/dashboard': {
      id: '/_authenticated/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthenticatedDashboardRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/brand-brain': {
      id: '/_authenticated/brand-brain'
      path: '/brand-brain'
      fullPath: '/brand-brain'
      preLoaderRoute: typeof AuthenticatedBrandBrainRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/beta-features': {
      id: '/_authenticated/beta-features'
      path: '/beta-features'
      fullPath: '/beta-features'
      preLoaderRoute: typeof AuthenticatedBetaFeaturesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/api-tokens': {
      id: '/_authenticated/api-tokens'
      path: '/api-tokens'
      fullPath: '/api-tokens'
      preLoaderRoute: typeof AuthenticatedApiTokensRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/admin': {
      id: '/_authenticated/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AuthenticatedAdminRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/pre-flight/': {
      id: '/_authenticated/pre-flight/'
      path: '/'
      fullPath: '/pre-flight/'
      preLoaderRoute: typeof AuthenticatedPreFlightIndexRouteImport
      parentRoute: typeof AuthenticatedPreFlightRoute
    }
    '/_authenticated/pre-flight-scripts/': {
      id: '/_authenticated/pre-flight-scripts/'
      path: '/'
      fullPath: '/pre-flight-scripts/'
      preLoaderRoute: typeof AuthenticatedPreFlightScriptsIndexRouteImport
      parentRoute: typeof AuthenticatedPreFlightScriptsRoute
    }
    '/_authenticated/post-flight/': {
      id: '/_authenticated/post-flight/'
      path: '/'
      fullPath: '/post-flight/'
      preLoaderRoute: typeof AuthenticatedPostFlightIndexRouteImport
      parentRoute: typeof AuthenticatedPostFlightRoute
    }
    '/_authenticated/marketplace/': {
      id: '/_authenticated/marketplace/'
      path: '/'
      fullPath: '/marketplace/'
      preLoaderRoute: typeof AuthenticatedMarketplaceIndexRouteImport
      parentRoute: typeof AuthenticatedMarketplaceRoute
    }
    '/_authenticated/marketplace/partner': {
      id: '/_authenticated/marketplace/partner'
      path: '/partner'
      fullPath: '/marketplace/partner'
      preLoaderRoute: typeof AuthenticatedMarketplacePartnerRouteImport
      parentRoute: typeof AuthenticatedMarketplaceRoute
    }
    '/_authenticated/marketplace/orders': {
      id: '/_authenticated/marketplace/orders'
      path: '/orders'
      fullPath: '/marketplace/orders'
      preLoaderRoute: typeof AuthenticatedMarketplaceOrdersRouteImport
      parentRoute: typeof AuthenticatedMarketplaceRoute
    }
    '/_authenticated/marketplace/import': {
      id: '/_authenticated/marketplace/import'
      path: '/import'
      fullPath: '/marketplace/import'
      preLoaderRoute: typeof AuthenticatedMarketplaceImportRouteImport
      parentRoute: typeof AuthenticatedMarketplaceRoute
    }
    '/_authenticated/marketplace/admin': {
      id: '/_authenticated/marketplace/admin'
      path: '/admin'
      fullPath: '/marketplace/admin'
      preLoaderRoute: typeof AuthenticatedMarketplaceAdminRouteImport
      parentRoute: typeof AuthenticatedMarketplaceRoute
    }
    '/_authenticated/marketplace/partner/': {
      id: '/_authenticated/marketplace/partner/'
      path: '/'
      fullPath: '/marketplace/partner/'
      preLoaderRoute: typeof AuthenticatedMarketplacePartnerIndexRouteImport
      parentRoute: typeof AuthenticatedMarketplacePartnerRoute
    }
    '/_authenticated/pre-flight/reports/$reportId': {
      id: '/_authenticated/pre-flight/reports/$reportId'
      path: '/reports/$reportId'
      fullPath: '/pre-flight/reports/$reportId'
      preLoaderRoute: typeof AuthenticatedPreFlightReportsReportIdRouteImport
      parentRoute: typeof AuthenticatedPreFlightRoute
    }
    '/_authenticated/pre-flight-scripts/review/$reviewId': {
      id: '/_authenticated/pre-flight-scripts/review/$reviewId'
      path: '/review/$reviewId'
      fullPath: '/pre-flight-scripts/review/$reviewId'
      preLoaderRoute: typeof AuthenticatedPreFlightScriptsReviewReviewIdRouteImport
      parentRoute: typeof AuthenticatedPreFlightScriptsRoute
    }
    '/_authenticated/marketplace/partner/reviews/$reviewId': {
      id: '/_authenticated/marketplace/partner/reviews/$reviewId'
      path: '/reviews/$reviewId'
      fullPath: '/marketplace/partner/reviews/$reviewId'
      preLoaderRoute: typeof AuthenticatedMarketplacePartnerReviewsReviewIdRouteImport
      parentRoute: typeof AuthenticatedMarketplacePartnerRoute
    }
  }
}

interface AuthenticatedMarketplacePartnerRouteChildren {
  AuthenticatedMarketplacePartnerIndexRoute: typeof AuthenticatedMarketplacePartnerIndexRoute
  AuthenticatedMarketplacePartnerReviewsReviewIdRoute: typeof AuthenticatedMarketplacePartnerReviewsReviewIdRoute
}

const AuthenticatedMarketplacePartnerRouteChildren: AuthenticatedMarketplacePartnerRouteChildren =
  {
    AuthenticatedMarketplacePartnerIndexRoute:
      AuthenticatedMarketplacePartnerIndexRoute,
    AuthenticatedMarketplacePartnerReviewsReviewIdRoute:
      AuthenticatedMarketplacePartnerReviewsReviewIdRoute,
  }

const AuthenticatedMarketplacePartnerRouteWithChildren =
  AuthenticatedMarketplacePartnerRoute._addFileChildren(
    AuthenticatedMarketplacePartnerRouteChildren,
  )

interface AuthenticatedMarketplaceRouteChildren {
  AuthenticatedMarketplaceAdminRoute: typeof AuthenticatedMarketplaceAdminRoute
  AuthenticatedMarketplaceImportRoute: typeof AuthenticatedMarketplaceImportRoute
  AuthenticatedMarketplaceOrdersRoute: typeof AuthenticatedMarketplaceOrdersRoute
  AuthenticatedMarketplacePartnerRoute: typeof AuthenticatedMarketplacePartnerRouteWithChildren
  AuthenticatedMarketplaceIndexRoute: typeof AuthenticatedMarketplaceIndexRoute
}

const AuthenticatedMarketplaceRouteChildren: AuthenticatedMarketplaceRouteChildren =
  {
    AuthenticatedMarketplaceAdminRoute: AuthenticatedMarketplaceAdminRoute,
    AuthenticatedMarketplaceImportRoute: AuthenticatedMarketplaceImportRoute,
    AuthenticatedMarketplaceOrdersRoute: AuthenticatedMarketplaceOrdersRoute,
    AuthenticatedMarketplacePartnerRoute:
      AuthenticatedMarketplacePartnerRouteWithChildren,
    AuthenticatedMarketplaceIndexRoute: AuthenticatedMarketplaceIndexRoute,
  }

const AuthenticatedMarketplaceRouteWithChildren =
  AuthenticatedMarketplaceRoute._addFileChildren(
    AuthenticatedMarketplaceRouteChildren,
  )

interface AuthenticatedPostFlightRouteChildren {
  AuthenticatedPostFlightIndexRoute: typeof AuthenticatedPostFlightIndexRoute
}

const AuthenticatedPostFlightRouteChildren: AuthenticatedPostFlightRouteChildren =
  {
    AuthenticatedPostFlightIndexRoute: AuthenticatedPostFlightIndexRoute,
  }

const AuthenticatedPostFlightRouteWithChildren =
  AuthenticatedPostFlightRoute._addFileChildren(
    AuthenticatedPostFlightRouteChildren,
  )

interface AuthenticatedPreFlightRouteChildren {
  AuthenticatedPreFlightIndexRoute: typeof AuthenticatedPreFlightIndexRoute
  AuthenticatedPreFlightReportsReportIdRoute: typeof AuthenticatedPreFlightReportsReportIdRoute
}

const AuthenticatedPreFlightRouteChildren: AuthenticatedPreFlightRouteChildren =
  {
    AuthenticatedPreFlightIndexRoute: AuthenticatedPreFlightIndexRoute,
    AuthenticatedPreFlightReportsReportIdRoute:
      AuthenticatedPreFlightReportsReportIdRoute,
  }

const AuthenticatedPreFlightRouteWithChildren =
  AuthenticatedPreFlightRoute._addFileChildren(
    AuthenticatedPreFlightRouteChildren,
  )

interface AuthenticatedPreFlightScriptsRouteChildren {
  AuthenticatedPreFlightScriptsIndexRoute: typeof AuthenticatedPreFlightScriptsIndexRoute
  AuthenticatedPreFlightScriptsReviewReviewIdRoute: typeof AuthenticatedPreFlightScriptsReviewReviewIdRoute
}

const AuthenticatedPreFlightScriptsRouteChildren: AuthenticatedPreFlightScriptsRouteChildren =
  {
    AuthenticatedPreFlightScriptsIndexRoute:
      AuthenticatedPreFlightScriptsIndexRoute,
    AuthenticatedPreFlightScriptsReviewReviewIdRoute:
      AuthenticatedPreFlightScriptsReviewReviewIdRoute,
  }

const AuthenticatedPreFlightScriptsRouteWithChildren =
  AuthenticatedPreFlightScriptsRoute._addFileChildren(
    AuthenticatedPreFlightScriptsRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedAdminRoute: typeof AuthenticatedAdminRoute
  AuthenticatedApiTokensRoute: typeof AuthenticatedApiTokensRoute
  AuthenticatedBetaFeaturesRoute: typeof AuthenticatedBetaFeaturesRoute
  AuthenticatedBrandBrainRoute: typeof AuthenticatedBrandBrainRoute
  AuthenticatedDashboardRoute: typeof AuthenticatedDashboardRoute
  AuthenticatedDrilldownRoute: typeof AuthenticatedDrilldownRoute
  AuthenticatedIamRoute: typeof AuthenticatedIamRoute
  AuthenticatedMarketplaceRoute: typeof AuthenticatedMarketplaceRouteWithChildren
  AuthenticatedOpportunitiesRoute: typeof AuthenticatedOpportunitiesRoute
  AuthenticatedOrderStatusTimeRoute: typeof AuthenticatedOrderStatusTimeRoute
  AuthenticatedOverviewRoute: typeof AuthenticatedOverviewRoute
  AuthenticatedPersonaOpportunitiesRoute: typeof AuthenticatedPersonaOpportunitiesRoute
  AuthenticatedPersonasRoute: typeof AuthenticatedPersonasRoute
  AuthenticatedPostFlightRoute: typeof AuthenticatedPostFlightRouteWithChildren
  AuthenticatedPreFlightRoute: typeof AuthenticatedPreFlightRouteWithChildren
  AuthenticatedPreFlightScriptsRoute: typeof AuthenticatedPreFlightScriptsRouteWithChildren
  AuthenticatedPromptsRoute: typeof AuthenticatedPromptsRoute
  AuthenticatedScriptDeliveryRoute: typeof AuthenticatedScriptDeliveryRoute
  AuthenticatedWorkspaceRoute: typeof AuthenticatedWorkspaceRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedAdminRoute: AuthenticatedAdminRoute,
  AuthenticatedApiTokensRoute: AuthenticatedApiTokensRoute,
  AuthenticatedBetaFeaturesRoute: AuthenticatedBetaFeaturesRoute,
  AuthenticatedBrandBrainRoute: AuthenticatedBrandBrainRoute,
  AuthenticatedDashboardRoute: AuthenticatedDashboardRoute,
  AuthenticatedDrilldownRoute: AuthenticatedDrilldownRoute,
  AuthenticatedIamRoute: AuthenticatedIamRoute,
  AuthenticatedMarketplaceRoute: AuthenticatedMarketplaceRouteWithChildren,
  AuthenticatedOpportunitiesRoute: AuthenticatedOpportunitiesRoute,
  AuthenticatedOrderStatusTimeRoute: AuthenticatedOrderStatusTimeRoute,
  AuthenticatedOverviewRoute: AuthenticatedOverviewRoute,
  AuthenticatedPersonaOpportunitiesRoute:
    AuthenticatedPersonaOpportunitiesRoute,
  AuthenticatedPersonasRoute: AuthenticatedPersonasRoute,
  AuthenticatedPostFlightRoute: AuthenticatedPostFlightRouteWithChildren,
  AuthenticatedPreFlightRoute: AuthenticatedPreFlightRouteWithChildren,
  AuthenticatedPreFlightScriptsRoute:
    AuthenticatedPreFlightScriptsRouteWithChildren,
  AuthenticatedPromptsRoute: AuthenticatedPromptsRoute,
  AuthenticatedScriptDeliveryRoute: AuthenticatedScriptDeliveryRoute,
  AuthenticatedWorkspaceRoute: AuthenticatedWorkspaceRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  LoginRoute: LoginRoute,
  AuthActionRoute: AuthActionRoute,
  AuthForgotPasswordRoute: AuthForgotPasswordRoute,
  AuthInviteRoute: AuthInviteRoute,
  AuthLinkRoute: AuthLinkRoute,
  AuthMcpAuthorizeRoute: AuthMcpAuthorizeRoute,
  MarketplaceVendorInviteRoute: MarketplaceVendorInviteRoute,
  STokenRoute: STokenRoute,
  SrTokenRoute: SrTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
